export const UserRoundIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 5.33325C10.6667 3.86049 9.47276 2.66659 8 2.66659C6.52724 2.66659 5.33333 3.86049 5.33333 5.33325C5.33333 6.80601 6.52724 7.99992 8 7.99992C9.47276 7.99992 10.6667 6.80601 10.6667 5.33325ZM12 5.33325C12 6.63057 11.3817 7.78275 10.4245 8.51359C11.0956 8.81016 11.714 9.22822 12.2428 9.75708C13.3681 10.8823 14 12.4086 14 13.9999C14 14.3681 13.7015 14.6666 13.3333 14.6666C12.9651 14.6666 12.6667 14.3681 12.6667 13.9999C12.6667 12.7622 12.1753 11.575 11.3001 10.6998C10.4796 9.87925 9.38465 9.39627 8.23112 9.33911L8 9.33325C6.76232 9.33325 5.57504 9.82462 4.69987 10.6998C3.8247 11.575 3.33333 12.7622 3.33333 13.9999C3.33333 14.3681 3.03486 14.6666 2.66667 14.6666C2.29848 14.6666 2 14.3681 2 13.9999C2 12.4086 2.63194 10.8823 3.75716 9.75708C4.28588 9.22836 4.90395 8.81015 5.57487 8.51359C4.61787 7.78273 4 6.63039 4 5.33325C4 3.12411 5.79086 1.33325 8 1.33325C10.2091 1.33325 12 3.12411 12 5.33325Z"
        fill="white"
      />
    </svg>
  );
};
